import React, { Component } from 'react';
import Meta from "../Meta";
import Header from "../header";
import Footer from "../footer";
import ListRender from "./ListRender";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default class Galeries extends Component {

    render() {
        if (this.props.loading) {
            return (
                <div>
                    <Loader />
                </div>
            );
        }

        const context = this.props.context;
        const { org, config } = context;
        const title = t`Galeries Photo de ${org.name}`;
        const description = t`Galeries Photo de ${org.name}`;

        return (
            <div>
                <Meta context={context} title={title} description={description} />
                <Header context={context} />
                <PageTitle context={context} title={t`Galeries Photo`} />
                <div style={{ marginTop: 20, minHeight: "50vh" }}>
                    <ListRender context={context} />
                </div>
                <Footer context={context} />
            </div>
        );
    }
}
